import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { clinicsGraphqlService } from '@/services/api/clinics/clinicsGraphqlService';

interface Timezone {
  timezone: string;
}

export const useTimezones = () => {
  const [timezones, setTimezones] = useState<Timezone[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  
  const { hasuraToken, user } = useAuth();

  useEffect(() => {
    const fetchTimezones = async () => {
      if (!user || !hasuraToken) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const data = await clinicsGraphqlService.getTimezones(hasuraToken);
        // Filter out null/undefined timezones
        const validTimezones = data.filter(item => item.timezone);
        setTimezones(validTimezones);
        setError(null);
      } catch (err) {
        console.error('Error fetching timezones:', err);
        setError('Failed to fetch timezones');
      } finally {
        setLoading(false);
      }
    };

    fetchTimezones();
  }, [hasuraToken, user]);

  return { timezones, loading, error };
};
